module.exports = {
  bindings: {
    reason: '<',
    choice: '=',
    note: '=',
  },
  controller: class {
    static $inject = [
      'ProductService',
    ];
    constructor(ProductService) {
      this.ProductService = ProductService;
    };

    get hasManitobaProduct() {
      return this.ProductService.isAvailable('MANITOBA_BOOKING');
    }
  },
  template: `
    <div ng-if="$ctrl.reason.visitReasonType && $ctrl.reason.visitReasonType !== 'nothing' && !$ctrl.reason.prohibitedMessage" class="reason-choices">
      <h2 class="title -main">
        {{ ($ctrl.hasManitobaProduct ? 'preferences_page.manitoba_language_access.title' : 'preferences_page.visit_reason.title') | translate}}
      </h2>
      <div class="box">
        <div class="field -select">
          <h3 class="title -sub">
            <strong>
            {{ ($ctrl.hasManitobaProduct ? 'preferences_page.manitoba_language_access.label' : 'preferences_page.visit_reason.label') | translate}}
            </strong><br>
            <span>
            {{ ($ctrl.hasManitobaProduct ? 'preferences_page.manitoba_language_access.legend' : 'preferences_page.visit_reason.legend') | translate}}
            </span>
          </h3>
          <div class="content">
            <select ng-model="$ctrl.choice" ng-if="$ctrl.reason.visitReasonType === 'both' || $ctrl.reason.visitReasonType === 'choices'">
              <option value="">{{'preferences_page.visit_reason.placeholder' | translate}}</option>
              <option ng-repeat="choice in $ctrl.reason.visitReasonChoices track by $index" value="{{choice}}">{{choice}}</option>
              <option value="other" translate="preferences_page.visit_reason.other" ng-if="$ctrl.reason.visitReasonType === 'both'"></option>
            </select>

            <div ng-if="$ctrl.choice === 'other' || $ctrl.reason.visitReasonType === 'free'">
              <label translate="preferences_page.visit_reason.specify" ng-if="$ctrl.choice === 'other'"></label>
              <input type="text" ng-model="$ctrl.note" maxlength="50"/>
              <span class="legend" translate="preferences_page.visit_reason.max_characters"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
};



// WEBPACK FOOTER //
// ./main/components/reasons/reason-visit-choices.js